import Facebook from '../../assets/images/asset/social_facebook.png';
import Instagram from '../../assets/images/asset/social_instagram.png';
import Twitter from '../../assets/images/asset/social_twitter.png';
import Website from '../../assets/images/asset/social_website.png';

export const assetData = {
  icons: [Facebook, Instagram, Twitter, Website],
};
